import { prepareOptions } from "@helpers/liveFloor";
import prepareDetails from "@helpers/prepareDetails";
import axios from "@common/api/desktop/axios";

class LiveFloorView {
  getFilters = async (OperatorId, options) => {
    const changed = prepareOptions(options);
    const response = await axios.put(`Comms/LFVfilters`, {
      OperatorId,
      details: prepareDetails(changed),
    });
    return response.data;
  };

  filterByMachine = async (
    OperatorId,
    CompanyId,
    SubCompanyId,
    SiteId,
    Options,
    Statuses,
  ) => {
    const changed = prepareOptions(Options);
    const params = {
      OperatorId,
      CompanyId: CompanyId || -1,
      SubCompanyId: SubCompanyId || -1,
      SiteId: SiteId || -1,
      Details: prepareDetails(changed),
      ...Statuses,
      PageNumber: 1,
    };

    const response = await axios.put(`comms/filterbymachine3`, params);
    return response.data;
  };

  filterByOperation = async (
    OperatorId,
    CompanyId,
    SubCompanyId,
    SiteId,
    Manufacturers,
    GameNames,
    Categories,
    PeriodId,
    FilterId,
  ) => {
    const data = {
      OperatorId,
      CompanyId: CompanyId || -1,
      SubCompanyId: SubCompanyId || -1,
      SiteId: SiteId || -1,
      Manufacturers,
      GameNames,
      Categories,
      PeriodId,
      FilterId,
    };

    const response = await axios.put(`comms/filterbyoperation/`, data);
    return response.data;
  };

  getPeriods = async () => {
    const response = await axios.get(`comms/periodfilter`);
    return response.data.map((period) => {
      return { key: period.id, value: period.id, text: period.name };
    });
  };

  getReports = async (operatorId) => {
    const response = await axios.get(`comms/filter3/${operatorId}`);
    return response.data.map((report) => {
      return { key: report.id, value: report.id, text: report.name };
    });
  };

  getSession = async (sessionid) => {
    const response = await axios.get(`sessions/details/${sessionid}`);
    return response.data;
  };

  getSessions = async (installationId, periodId, showCashSessions) => {
    const response = await axios.get(
      `sessions/commsui/sessionsbyperiod2/${installationId},${periodId},${showCashSessions}`,
    );
    return response.data;
  };

  getEvents = async (
    installationId,
    periodId,
    showEvents = false,
    pageNumber = 1,
  ) => {
    const response = await axios.get(
      `Installation/EventsByPeriod2/${installationId},${periodId},${showEvents},${pageNumber}`,
    );
    return response.data;
  };

  getPerformanceGrid = async (data) => {
    const response = await axios.put(
      `Comms/performance`,
      this.prepareData(data),
    );
    return response.data;
  };

  prepareData = (data) => {
    const { CompanyId, SubCompanyId, SiteId } = data;
    return {
      ...data,
      showOfflineOnly: data.offlineOnly,
      CompanyId: CompanyId || -1,
      SubCompanyId: SubCompanyId || -1,
      SiteId: SiteId || -1,
    };
  };

  getCashInBoxGrid = async (data) => {
    const response = await axios.put(`Comms/cashinbox`, this.prepareData(data));
    return response.data;
  };

  getCashInBoxExport = async (data) => {
    return await axios.put(`Comms/cashinbox/export`, this.prepareData(data), {
      responseType: "arraybuffer",
    });
  };

  getPerformanceExport = async (data) => {
    return await axios.put(`Comms/performance/export`, this.prepareData(data), {
      responseType: "arraybuffer",
    });
  };

  getCashInBoxPositions = async (data) => {
    const response = await axios.put(
      `Comms/cashinbox/positions`,
      this.prepareData(data),
    );
    return response.data;
  };

  getCashInBoxPositionsExport = async (data) => {
    return await axios.put(
      `Comms/cashinbox/positions/export/`,
      this.prepareData(data),
      { responseType: "arraybuffer" },
    );
  };

  getCashInBoxEvents = async (installationId, numDays, showEvents) => {
    const response = await axios.get(
      `Comms/cashinbox/positions/events/${installationId},${numDays},${showEvents}`,
    );
    return response.data;
  };

  getCashInBoxEventsExport = async (installationId, numDays, showEvents) => {
    const response = await axios.get(
      `Comms/cashinbox/positions/events/export/${installationId},${numDays},${showEvents}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getPerformancePositions = async (data) => {
    const response = await axios.put(
      `Comms/performance/positions`,
      this.prepareData(data),
    );
    return response.data;
  };

  getPerformancePositionsExport = async (data) => {
    return await axios.put(
      `Comms/performance/positions/export/`,
      this.prepareData(data),
      { responseType: "arraybuffer" },
    );
  };

  getPerformanceEvents = async (installationId, numDays, showEvents) => {
    const response = await axios.get(
      `Comms/performance/positions/events/${installationId},${numDays},${showEvents}`,
    );
    return response.data;
  };

  getPerformanceEventsExport = async (installationId, numDays, showEvents) => {
    const response = await axios.get(
      `Comms/performance/positions/events/export/${installationId},${numDays},${showEvents}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };
}

const livefloorview = new LiveFloorView();
export default livefloorview;
